import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUser from '../../hooks/useUser';
import CEOSalesReporta from './ceo/SalesReporta';
import AdminSalesReporta from './admin/SalesReporta';
import ManagerSalesReporta from './manager/SalesReporta';
import { clearError } from '../../store/slices/salesReportaSlice';

const SalesReporta = () => {
    const dispatch = useDispatch();
    const { userRole } = useUser();

    useEffect(() => {
        dispatch(clearError());
    }, [dispatch]);

    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    if (roleLower === 'ceo') {
        return <CEOSalesReporta />;
    } else if (roleLower === 'admin') {
        return <AdminSalesReporta />;
    } else if (roleLower === 'manager') {
        return <ManagerSalesReporta />;
    } else {
        return <ManagerSalesReporta />;
    }
};

export default SalesReporta;
